module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "学生异动影响",
      "tags": ['被波及 → 换老师 → 保时 / 改时 → 留存'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.typeOptions,
      "label": "异动类型"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.newOptions
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.newOnly),
      callback: function($$v) {
        _vm.newOnly = $$v
      },
      expression: "newOnly"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 窗口：生效日在近 " + _vm._s(_vm.days) + " 天（含今天）· 学生按最早一起事件归因")])], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "block-lead"
  }, [_vm._v("每个学生都在这条链上：被波及 → 换老师 → 保住或改掉原时段 → 留存或流失。看学生卡在哪一步。")]), _vm._v(" "), _c('div', {
    staticClass: "grid g21"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生状态链路"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("近 " + _vm._s(_vm.days) + " 天 · " + _vm._s(_vm.fmtNum(_vm.d.studentCount)) + " 名学生")])])]), _vm._v(" "), _vm._l((_vm.chainRows), function(row) {
    return _c('div', {
      key: row.key,
      staticClass: "funnel-row"
    }, [_c('div', {
      staticClass: "funnel-label"
    }, [_vm._v(_vm._s(row.label))]), _vm._v(" "), _c('div', {
      staticClass: "funnel-track"
    }, [_c('div', {
      staticClass: "funnel-fill",
      style: ({
        width: row.width + '%',
        background: row.color
      })
    }, [_vm._v(_vm._s(_vm.fmtNum(row.value)))])]), _vm._v(" "), _c('div', {
      staticClass: "funnel-rate"
    }, [_vm._v(_vm._s(row.rate))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("\n          盯两个缺口："), _c('b', [_vm._v("「待换老师」是运营的待办清单")]), _vm._v("（当前 " + _vm._s(_vm.fmtNum(_vm.d.waitingCount)) + " 人，超 7 天 " + _vm._s(_vm.fmtNum(_vm.d.waitingOver7Count)) + " 人），「改时间」是下一阶段流失的种子（" + _vm._s(_vm.fmtNum(_vm.d.changeSlotCount)) + " 人）。\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.depthRows,
      "unit": "人"
    }
  }), _vm._v(" "), (_vm.depthInsight) ? _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v(_vm._s(_vm.depthInsight))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("换老师的两种结果"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.switchedCount)) + " 名已换完学生 · 按是否保住原时段拆分")])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-boxes"
  }, [_c('div', {
    staticClass: "compare-box"
  }, [_c('div', {
    staticClass: "compare-box-title is-healthy"
  }, [_vm._v("保时换老师")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.keepSlotCount))), _c('small', [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v("原时段不变 · 占已换 " + _vm._s(_vm.fmtRate(_vm.d.keepSlotRate)) + " · 30 天留存 "), _c('b', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.keepRetain30Rate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box is-danger"
  }, [_c('div', {
    staticClass: "compare-box-title is-danger"
  }, [_vm._v("换老师 + 被迫改时间")]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-value is-danger"
  }, [_vm._v(_vm._s(_vm.fmtNum(_vm.d.changeSlotCount))), _c('small', [_vm._v("人")])]), _vm._v(" "), _c('div', {
    staticClass: "compare-box-foot"
  }, [_vm._v("时段也变了 · 占已换 " + _vm._s(_vm.fmtRate(_vm.d.changeSlotRate)) + " · 30 天留存 "), _c('b', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.changeRetain30Rate)))])])])]), _vm._v(" "), (_vm.retainGap != null) ? _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v("\n          同样是换老师，保时和改时的 30 天留存相差 "), _c('b', [_vm._v(_vm._s(_vm.retainGap) + "pp")]), _vm._v("。真正伤人的往往不是换老师本身，而是「换人 + 作息也变了」。\n        ")]) : _vm._e(), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(4), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.keepRows,
      "unit": "",
      "right-width": 130
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "kv"
  }, [_c('dt', [_vm._v("保时换老师 30 天留存")]), _c('dd', {
    staticClass: "t-healthy"
  }, [_vm._v(_vm._s(_vm.fmtRate(_vm.d.keepRetain30Rate)))]), _vm._v(" "), _c('dt', [_vm._v("改时换老师 30 天留存")]), _c('dd', {
    staticClass: "t-danger"
  }, [_vm._v(_vm._s(_vm.fmtRate(_vm.d.changeRetain30Rate)))]), _vm._v(" "), _c('dt', [_vm._v("留存差值")]), _c('dd', [_vm._v(_vm._s(_vm.retainGap == null ? '—' : _vm.retainGap + 'pp'))])]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("关闭时间关掉的正是学生原来上课的时段，要保时只能找同档期的其他老师，保时率天然更难。")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("受影响学生清单")]), _vm._v(" "), _c('span', {
    staticClass: "section-right"
  }, [_vm._v(_vm._s(_vm.listSub))])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    class: {
      'is-disabled': _vm.exporting
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? '导出中…' : '导出名单 →'))])]), _vm._v(" "), _c('div', {
    staticClass: "section-filters list-filters"
  }, [_c('span', {
    staticClass: "filter-group teacher-filter"
  }, [_c('span', {
    staticClass: "filter-label"
  }, [_vm._v("原老师")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tchId),
      callback: function($$v) {
        _vm.tchId = $$v
      },
      expression: "tchId"
    }
  }, _vm._l((_vm.teachers), function(t) {
    return _c('Option', {
      key: t.id,
      attrs: {
        "value": t.id
      }
    }, [_vm._v(_vm._s(t.name || t.id))])
  }), 1)], 1), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.switchOptions,
      "label": "换老师状态"
    },
    on: {
      "on-change": _vm.load
    },
    model: {
      value: (_vm.switchStatus),
      callback: function($$v) {
        _vm.switchStatus = $$v
      },
      expression: "switchStatus"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-note"
  }, [_vm._v("※ 原老师 / 换老师状态只过滤下方名单与导出，上方指标不变")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(row) {
    return _c('tr', {
      key: row.uid + '-' + row.tchId + '-' + row.effectiveDate,
      class: {
        'is-priority': row.newPriority
      }
    }, [_c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.adviserName || '—'))]), _vm._v(" "), _c('td', [(row.newPriority) ? _c('span', {
      staticClass: "badge is-danger"
    }, [_vm._v("新生优先")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "t-muted"
    }, [_vm._v(_vm._s(_vm.isNum(row.tenureDays) ? '开课第 ' + row.tenureDays + ' 天' : '—'))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || row.tchId))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.effectiveDate || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.origSlot || '—'))]), _vm._v(" "), _c('td', [(row.switchStatus === 'waiting') ? _c('span', {
      staticClass: "badge is-warning"
    }, [_vm._v("待换老师")]) : [_c('span', {
      staticClass: "badge is-healthy"
    }, [_vm._v("已换完")]), _vm._v(" "), (row.keepSlot === true) ? _c('span', {
      staticClass: "badge is-healthy"
    }, [_vm._v("保时")]) : (row.keepSlot === false) ? _c('span', {
      staticClass: "badge is-danger"
    }, [_vm._v("改时间")]) : _vm._e()]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.newTchName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.isNum(row.switchDays) ? row.switchDays + ' 天' : '—'))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', {
      class: {
        't-danger': _vm.num(row.lostLessons) >= 4
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lostLessons)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.remainHours)))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.level)
    }, [_vm._v(_vm._s(row.level || '—'))]), _c('span', {
      staticClass: "t-muted"
    }, [_vm._v(" " + _vm._s(_vm.fmtNum(row.score)))])])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("当前筛选下没有受影响学生")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(7), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.regapRows,
      "unit": "人"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_vm._l((_vm.byType), function(row) {
    return _c('tr', {
      key: row.type
    }, [_c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.typeBadge(row.type)
    }, [_vm._v(_vm._s(_vm.typeLabel(row.type)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.students)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.switched)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtRate(row.switched7dRate)))]), _vm._v(" "), _c('td', {
      staticClass: "num",
      class: {
        't-danger': _vm.isNum(row.keepSlotRate) && row.keepSlotRate < 70
      }
    }, [_vm._v(_vm._s(_vm.fmtRate(row.keepSlotRate)))]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.avgLost)))])])
  }), _vm._v(" "), (!_vm.byType.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("暂无数据")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "note is-danger"
  }, [_vm._v("人均损失课次高的类型，说明学生在换老师之前就已经断课了。这类学生换完老师要加一轮主动沟通和首课质检。")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("学生走到哪一步")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("损失课次分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("按学生 · 生效后 14 天应上未上")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note is-warning"
  }, [_vm._v("\n          排课侧建议："), _c('b', [_vm._v("先锁时段，再配老师")]), _vm._v("。宁可多等两天找一个能上原时段的老师，也别急着塞一个时段错位的。\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("各类型保时率"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("换老师后仍在原时段（±30 分钟）的比例")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生清单"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("前 50 名 · 导出为全部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("新生状态")]), _vm._v(" "), _c('th', [_vm._v("原老师")]), _vm._v(" "), _c('th', [_vm._v("异动类型")]), _vm._v(" "), _c('th', [_vm._v("生效日")]), _vm._v(" "), _c('th', [_vm._v("原时段")]), _vm._v(" "), _c('th', [_vm._v("换老师状态")]), _vm._v(" "), _c('th', [_vm._v("新老师")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("迁移天数")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("损失课次")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("剩余课时")]), _vm._v(" "), _c('th', [_vm._v("风险")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("换老师时长分布"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("已换完学生 · 生效日到首次已选新老师课")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("异动类型 × 学生结果"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("学生经历了什么，而不是老师发生了什么")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("异动类型")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("波及学生")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("已换完")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("7 天换完率")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("保时率")]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("人均损失课次")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99b92ee8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/TchImpactChange.vue
// module id = 1911
// module chunks = 8